import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum SegmentId {
  OTHER = 0,
  BAR = 1,
  RETAIL_SALES = 2,
  GASTRO = 3,
  INTERNET = 4,
  MASSAGES = 5,
  CITY_FEES = 6,
  MINI_BAR = 7,
  PARKING = 8,
  OTHER_FEES = 9,
  LEASE = 10,
  LEASE_SPACES = 11,
  RESTAURANT = 12,
  SAUNA = 13,
  DISCOUNT_SURCHARGE = 14,
  SERVICES = 15,
  SPORT = 16,
  SPORTS_GROUND = 17,
  MEALS = 18,
  PHONE = 19,
  ACCOMMODATION = 20,
  WARE = 21,
  WELLNESS = 22,
  DRINKS = 23,
  TRANSFER = 24,
  HOUSEKEEPING = 25,
  COSMETICS = 26,
  DAMAGE = 27,
  SPECIAL_PRICES = 28,
  CANCELLATION_FEES = 29,
  MINIBAR_MEALS = 30,
  MINIBAR_DRINK = 31,
  CONFERENCE = 32,
  PACKAGE = 33,
  INVENTORY = 34,
  STAFF = 35,
  GAMING_CLUB = 36,
  FIXES = 37,
  BREAKFAST = 38,
  HALF_BOARD = 39,
  FULL_BOARD = 40,
  HEALING = 41,
  BALNEO = 42,
  LAUNDRY = 43,
  COFFEE_BREAK = 44,
  BUFFET = 45,
  CATERING = 46,
  ALCOHOLIC_DRINKS_PACKAGE = 47,
  NONALCOHOLIC_DRINKS_PACKAGE = 48,
  HALF_BOARD_PACKAGE = 49,
  FULL_BOARD_PACKAGE = 50,
  RETURNABLE_BOTTLE_FEES = 51,
  SINGLE_PURPOSE_COUPON = 52,
  MULTI_PURPOSE_COUPON = 53,
  REUSABLE_CUP = 54,
  OWNER = 55,
  CONFERENCE_FOOD = 56,
  CONFERENCE_DRINK = 57,
  RESTAURANT_SYSTEM_SALES = 58,
  EV_CHARGING_STATION = 59,
}

export class Segment extends Codebook<SegmentId> {
  private constructor(
    public readonly id: SegmentId,
    public readonly name: () => string,
  ) {
    super(id)
  }

  static readonly OTHER = new Segment(SegmentId.OTHER, () => $t('Other'))
  static readonly BAR = new Segment(SegmentId.BAR, () => $t('Bar'))
  static readonly RETAIL_SALES = new Segment(SegmentId.RETAIL_SALES, () => $t('Retail sales'))
  static readonly GASTRO = new Segment(SegmentId.GASTRO, () => $t('Gastro'))
  static readonly INTERNET = new Segment(SegmentId.INTERNET, () => $t('Internet'))
  static readonly MASSAGES = new Segment(SegmentId.MASSAGES, () => $t('Massages'))
  static readonly CITY_FEES = new Segment(SegmentId.CITY_FEES, () => $t('City fees'))
  static readonly MINI_BAR = new Segment(SegmentId.MINI_BAR, () => $t('Mini bar'))
  static readonly PARKING = new Segment(SegmentId.PARKING, () => $t('Parking'))
  static readonly OTHER_FEES = new Segment(SegmentId.OTHER_FEES, () => $t('Other fees'))
  static readonly LEASE = new Segment(SegmentId.LEASE, () => $t('Lease'))
  static readonly LEASE_SPACES = new Segment(SegmentId.LEASE_SPACES, () => $t('Lease spaces'))
  static readonly RESTAURANT = new Segment(SegmentId.RESTAURANT, () => $t('Restaurant'))
  static readonly SAUNA = new Segment(SegmentId.SAUNA, () => $t('Sauna'))
  static readonly DISCOUNT_SURCHARGE = new Segment(SegmentId.DISCOUNT_SURCHARGE, () =>
    $t('Discount / surcharge'),
  )
  static readonly SERVICES = new Segment(SegmentId.SERVICES, () => $t('Services'))
  static readonly SPORT = new Segment(SegmentId.SPORT, () => $t('Sport'))
  static readonly SPORTS_GROUND = new Segment(SegmentId.SPORTS_GROUND, () => $t('Sports ground'))
  static readonly MEALS = new Segment(SegmentId.MEALS, () => $t('Meals'))
  static readonly PHONE = new Segment(SegmentId.PHONE, () => $t('Phone'))
  static readonly ACCOMMODATION = new Segment(SegmentId.ACCOMMODATION, () => $t('Accommodation'))
  static readonly WARE = new Segment(SegmentId.WARE, () => $t('Ware'))
  static readonly WELLNESS = new Segment(SegmentId.WELLNESS, () => $t('Wellness'))
  static readonly DRINKS = new Segment(SegmentId.DRINKS, () => $t('Drinks'))
  static readonly TRANSFER = new Segment(SegmentId.TRANSFER, () => $t('Transfer'))
  static readonly HOUSEKEEPING = new Segment(SegmentId.HOUSEKEEPING, () => $t('Housekeeping'))
  static readonly COSMETICS = new Segment(SegmentId.COSMETICS, () => $t('Cosmetics'))
  static readonly DAMAGE = new Segment(SegmentId.DAMAGE, () => $t('Damage'))
  static readonly SPECIAL_PRICES = new Segment(SegmentId.SPECIAL_PRICES, () => $t('Special prices'))
  static readonly CANCELLATION_FEES = new Segment(SegmentId.CANCELLATION_FEES, () =>
    $t('Cancellation fees'),
  )
  static readonly MINIBAR_MEALS = new Segment(SegmentId.MINIBAR_MEALS, () => $t('Minibar meals'))
  static readonly MINIBAR_DRINK = new Segment(SegmentId.MINIBAR_DRINK, () => $t('Minibar drink'))
  static readonly CONFERENCE = new Segment(SegmentId.CONFERENCE, () => $t('Conference'))
  static readonly PACKAGE = new Segment(SegmentId.PACKAGE, () => $t('Package'))
  static readonly INVENTORY = new Segment(SegmentId.INVENTORY, () => $t('Inventory'))
  static readonly STAFF = new Segment(SegmentId.STAFF, () => $t('Staff'))
  static readonly GAMING_CLUB = new Segment(SegmentId.GAMING_CLUB, () => $t('Gaming club'))
  static readonly FIXES = new Segment(SegmentId.FIXES, () => $t('Fixes'))
  static readonly BREAKFAST = new Segment(SegmentId.BREAKFAST, () => $t('Breakfast'))
  static readonly HALF_BOARD = new Segment(SegmentId.HALF_BOARD, () => $t('Half-board'))
  static readonly FULL_BOARD = new Segment(SegmentId.FULL_BOARD, () => $t('Full-board'))
  static readonly HEALING = new Segment(SegmentId.HEALING, () => $t('Healing'))
  static readonly BALNEO = new Segment(SegmentId.BALNEO, () => $t('Balneo'))
  static readonly LAUNDRY = new Segment(SegmentId.LAUNDRY, () => $t('Laundry'))
  static readonly COFFEE_BREAK = new Segment(SegmentId.COFFEE_BREAK, () => $t('Coffee break'))
  static readonly BUFFET = new Segment(SegmentId.BUFFET, () => $t('Buffet'))
  static readonly CATERING = new Segment(SegmentId.CATERING, () => $t('Catering'))
  static readonly ALCOHOLIC_DRINKS_PACKAGE = new Segment(SegmentId.ALCOHOLIC_DRINKS_PACKAGE, () =>
    $t('Alcoholic drinks package'),
  )
  static readonly NONALCOHOLIC_DRINKS_PACKAGE = new Segment(
    SegmentId.NONALCOHOLIC_DRINKS_PACKAGE,
    () => $t('Non-alcoholic drinks package'),
  )
  static readonly HALF_BOARD_PACKAGE = new Segment(SegmentId.HALF_BOARD_PACKAGE, () =>
    $t('Half-board package'),
  )
  static readonly FULL_BOARD_PACKAGE = new Segment(SegmentId.FULL_BOARD_PACKAGE, () =>
    $t('Full-board package'),
  )
  static readonly RETURNABLE_BOTTLE_FEES = new Segment(SegmentId.RETURNABLE_BOTTLE_FEES, () =>
    $t('Refundable bottle fee'),
  )
  static readonly SINGLE_PURPOSE_COUPON = new Segment(SegmentId.SINGLE_PURPOSE_COUPON, () =>
    $t('One purpose coupon'),
  )
  static readonly MULTI_PURPOSE_COUPON = new Segment(SegmentId.MULTI_PURPOSE_COUPON, () =>
    $t('Multi purpose coupon'),
  )
  static readonly REUSABLE_CUP = new Segment(SegmentId.REUSABLE_CUP, () => $t('Reusable cup'))
  static readonly OWNER = new Segment(SegmentId.OWNER, () => $t('Owner'))
  static readonly CONFERENCE_FOOD = new Segment(SegmentId.CONFERENCE_FOOD, () =>
    $t('Conference food'),
  )
  static readonly CONFERENCE_DRINK = new Segment(SegmentId.CONFERENCE_DRINK, () =>
    $t('Conference drink'),
  )
  static readonly RESTAURANT_SYSTEM_SALES = new Segment(SegmentId.RESTAURANT_SYSTEM_SALES, () =>
    $t('Restaurant system sales'),
  )
  static readonly EV_CHARGING_STATION = new Segment(SegmentId.EV_CHARGING_STATION, () =>
    $t('EV charging station'),
  )
}
